<script scope>
import { getBooks } from '@/services/getbookServices';
export default {
name: 'CPGChat',

data() {
    return {
        book_data: [],
        showSelectionCard: true,
        selectedSpecialty: '',
        selectedBook: null
    }
},

computed: {
    filteredBooks() {
    return this.book_data.book_list?.filter(
        book => book.specialty === this.selectedSpecialty
    ) || []
    }
},

mounted() {
    this.fetch_book_selection()
},

methods: {
    async fetch_book_selection() {
        this.book_data = await getBooks()
        //console.log(this.book_data)
    },

    cancelSelection() {
      this.showSelectionCard = false
      this.selectedSpecialty = this.selectedBook?.specialty || ''
    },

    confirmSelection() {
      if (this.selectedBook) {
        this.$emit('book-selected', this.selectedBook)
        this.showSelectionCard = false
      }
    },

    changeSelection(){
        this.showSelectionCard = true
    }
}

}
</script>

<template>
    <div>
      <!-- Show selected book info if exists -->
      <div v-if="selectedBook && !showSelectionCard" class="selected-book-card">
        <div class="book-info">
          <h4>{{ selectedBook.book_name }}</h4>
          <p>Specialty: {{ selectedBook.specialty }}</p>
        </div>
        <button class="btn btn-outline-primary" @click="changeSelection()">
          Change
        </button>
      </div>
  
      <!-- Book Selection Card -->
      <div v-if="!selectedBook || showSelectionCard && book_data" class="selection-card">
        <div class="card-header">
          <h3>Select and Ask</h3>
        </div>
        
        <div class="card-body">
          <!-- Specialty Selection -->
          <div class="specialty-section">
            <label>Select Specialty:</label>
            <select v-model="selectedSpecialty" class="form-select">
              <option value="">Choose a specialty</option>
              <option v-for="specialty in (book_data.specialty_list || []).slice().sort()" 
                      :key="specialty" 
                      :value="specialty">
                {{ specialty }}
              </option>

            </select>
          </div>
  
          <!-- Book Selection -->
          <div class="book-section" v-if="selectedSpecialty">
            <label>Select Book:</label>
            <select v-model="selectedBook" class="form-select">
              <option value="">Choose a book</option>
              <option v-for="book in filteredBooks" 
                      :key="book.id" 
                      :value="book">
                {{ book.book_name }}
              </option>
            </select>
          </div>
        </div>
  
        <div class="card-footer">
          <button class="btn btn-primary" 
                  @click="confirmSelection" 
                  :disabled="!selectedBook">
            Confirm Selection
          </button>
        </div>
      </div>
    </div>
</template>
  
<style scoped>
/* Base styles */
.selection-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 0 20px;
}

.selection-card {
  background: var(--light-bg);
  border: 1px solid var(--light-border);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.dark-mode .selection-card {
  background: var(--dark-bg);
  border-color: var(--dark-border);
}

.selected-book-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid var(--light-border);
  border-radius: 8px;
  background: var(--light-bg);
  margin-bottom: 16px;
  transition: all 0.2s ease;
}

.dark-mode .selected-book-card {
  background: var(--dark-bg);
  border-color: var(--dark-border);
}

.selected-book-card:hover {
  border-color: var(--light-primary);
}

.dark-mode .selected-book-card:hover {
  border-color: var(--dark-primary);
}

.book-info {
  flex-grow: 1;
  padding-right: 20px;
}

.book-info h4 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--light-text);
  font-weight: 500;
  line-height: 1.4;
}

.dark-mode .book-info h4 {
  color: var(--dark-text);
}

.book-info p {
  margin: 4px 0 0;
  color: var(--light-text-secondary);
  font-size: 0.9rem;
}

.dark-mode .book-info p {
  color: var(--dark-text-secondary);
}

.card-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--light-border);
}

.dark-mode .card-header {
  border-color: var(--dark-border);
}

.card-header h3 {
  margin: 0;
  font-size: 1.2rem;
  color: var(--light-text);
  font-weight: 500;
}

.dark-mode .card-header h3 {
  color: var(--dark-text);
}

.card-body {
  padding: 20px;
}

.card-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--light-border);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.dark-mode .card-footer {
  border-color: var(--dark-border);
}

.specialty-section,
.book-section {
  margin-bottom: 16px;
}

.specialty-section label,
.book-section label {
  display: block;
  margin-bottom: 8px;
  color: var(--light-text-secondary);
  font-weight: 500;
  font-size: 0.9rem;
}

.dark-mode .specialty-section label,
.dark-mode .book-section label {
  color: var(--dark-text-secondary);
}

.form-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--light-border);
  border-radius: 6px;
  font-size: 0.9rem;
  color: var(--light-text);
  background-color: var(--light-bg);
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
}

.dark-mode .form-select {
  background-color: var(--dark-bg);
  color: var(--dark-text);
  border-color: var(--dark-border);
}

.form-select:focus {
  outline: none;
  border-color: var(--light-primary);
}

.dark-mode .form-select:focus {
  border-color: var(--dark-primary);
}

.btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--light-primary);
  color: white;
  border: none;
}

.dark-mode .btn-primary {
  background-color: var(--dark-primary);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--light-primary-hover);
}

.dark-mode .btn-primary:hover:not(:disabled) {
  background-color: var(--dark-primary-hover);
}

.btn-outline-primary {
  color: var(--light-primary);
  border: 1px solid var(--light-primary);
  background: transparent;
}

.dark-mode .btn-outline-primary {
  color: var(--dark-primary);
  border-color: var(--dark-primary);
}

.btn-outline-primary:hover {
  background-color: var(--light-primary);
  color: white;
}

.dark-mode .btn-outline-primary:hover {
  background-color: var(--dark-primary);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .selected-book-card {
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }

  .book-info {
    padding-right: 0;
    padding-bottom: 12px;
  }

  .card-header,
  .card-body,
  .card-footer {
    padding: 16px;
  }

  .btn {
    padding: 8px 16px;
  }
}

@media (max-width: 480px) {
  .card-footer {
    flex-direction: column-reverse;
  }

  .btn {
    width: 100%;
  }
}
</style>
